export const postPuzzle = puzzle =>
    window.fetch('https://akademia.uczymydzieciprogramowac.pl/pl/api/puzzle', {
        method: 'POST',
        body: JSON.stringify({puzzle: puzzle})
    }).then(response => response.clone().json());

export const getPuzzle = hash =>
    window.fetch('https://akademia.uczymydzieciprogramowac.pl/pl/api/puzzle/hash/' + hash, {method: 'GET'})
        .then(response => response.json());



// WEBPACK FOOTER //
// ./src/api.js